// ═══════════════════════════════════════════════════════════════════════════
// 📂 CATEGORY ACCORDION - Accordion categoria con bordo verde
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';
import MemoryGridCompact from './MemoryGridCompact';

/**
 * Accordion singola categoria espandibile
 *
 * @param {string} category - Nome categoria
 * @param {number} count - Numero ricordi
 * @param {Array} memories - Array di ricordi
 * @param {boolean} isExpanded - Se espanso
 * @param {function} onToggle - Callback toggle
 * @param {function} onEdit - Callback edit ricordo
 */
function CategoryAccordion({ category, count, memories, isExpanded, onToggle, onEdit }) {
  return (
    <div style={styles.container}>
      {/* Header cliccabile */}
      <button style={styles.header} onClick={onToggle}>
        <div style={styles.headerLeft}>
          <h4 style={styles.title}>{category}</h4>
          <span style={styles.count}>
            {count} ricord{count === 1 ? 'o' : 'i'}
          </span>
        </div>
        <span style={styles.icon}>{isExpanded ? '−' : '+'}</span>
      </button>

      {/* Body espandibile con grid */}
      {isExpanded && (
        <div style={styles.body}>
          <MemoryGridCompact memories={memories} onEdit={onEdit} />
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 STYLES
// ═══════════════════════════════════════════════════════════════════════════

const styles = {
  container: {
    border: '1px solid #E5E5E5',
    borderLeft: '4px solid #22C55E',
    borderRadius: '8px',
    marginBottom: '12px',
    overflow: 'hidden',
    background: '#FFFFFF',
  },

  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    transition: 'background 200ms',
  },

  headerLeft: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '12px',
  },

  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#171717',
    margin: 0,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  count: {
    fontSize: '13px',
    color: '#737373',
    fontWeight: 400,
  },

  icon: {
    fontSize: '24px',
    color: '#A3A3A3',
    fontWeight: 300,
    lineHeight: 1,
  },

  body: {
    padding: '0 16px 16px 16px',
    background: '#FAFAFA',
  },
};

export default CategoryAccordion;
